export default {"src":"/_next/static/media/Vector-1-gradient.66cf1217.svg","height":208,"width":224,"blurWidth":0,"blurHeight":0};